import { useMutation } from '@tanstack/react-query';
import { registerUser, RegisterUserRequest } from '@/api/register-user';
import { toast } from 'sonner';

export function useRegister() {
  return useMutation({
    mutationFn: async (userData: RegisterUserRequest) => {
      const result = await registerUser(userData);
      if (result.err) {
        console.error(result.val.devMessage)
        toast.error("Error al registrar usuario", {
          description: result.val.message,
        });
        throw new Error(result.val.message);
      }

      toast.success("Registro exitoso", {
        description: result.val,
      });
      return result.val;
    },
  });
} 